"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ScrollInViewInterface_1 = require("./ScrollInViewInterface");
class ScrollInView {
    /**
     * @inheritDoc
     */
    isInView(element, type = ScrollInViewInterface_1.ScrollInViewType.TOP) {
        const position = element.getBoundingClientRect();
        const windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        const yTop = position.top;
        const yBottom = position.top + position.height;
        if (type === ScrollInViewInterface_1.ScrollInViewType.ANY) {
            return (yTop < 0 && yBottom > windowHeight) ||
                (yTop > 0 && yTop < windowHeight) ||
                (yBottom > 0 && yBottom < windowHeight);
        }
        else if (type === ScrollInViewInterface_1.ScrollInViewType.TOP) {
            return (yTop > 0 && yTop < windowHeight);
        }
        else if (type === ScrollInViewInterface_1.ScrollInViewType.BOTTOM) {
            return (yBottom > 0 && yBottom < windowHeight);
        }
    }
    /**
     * @inheritDoc
     */
    scrollInView(element, type = ScrollInViewInterface_1.ScrollInViewType.TOP) {
        if (element.scrollIntoView) {
            if (type === ScrollInViewInterface_1.ScrollInViewType.ANY) {
                element.scrollIntoView({ block: "nearest", behavior: "smooth" });
            }
            else if (type === ScrollInViewInterface_1.ScrollInViewType.TOP) {
                element.scrollIntoView({ block: "start", behavior: "smooth" });
            }
            else if (type === ScrollInViewInterface_1.ScrollInViewType.BOTTOM) {
                element.scrollIntoView({ block: "end", behavior: "smooth" });
            }
        }
        else {
            const position = element.getBoundingClientRect();
            const windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            const yTop = position.top;
            const yBottom = position.top + position.height;
            const padding = 10;
            if (type === ScrollInViewInterface_1.ScrollInViewType.ANY) {
                document.documentElement.scrollTop -= -yTop + padding;
            }
            else if (type === ScrollInViewInterface_1.ScrollInViewType.TOP) {
                document.documentElement.scrollTop -= -yTop + padding;
            }
            else if (type === ScrollInViewInterface_1.ScrollInViewType.BOTTOM) {
                document.documentElement.scrollTop += (yBottom + padding) - windowHeight;
            }
        }
    }
}
exports.default = ScrollInView;
